import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const FilterListIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 17.551447 20" {...props}>
            <path
                d="M8.333 15h3.334v-1.667H8.333V15zM2.5 5v1.667h15V5h-15zM5 10.833h10V9.167H5v1.666z"
                transform="translate(-1090 -74) translate(248 48) translate(824 16) translate(18 10)"
            />
        </SvgIcon>
    );
};
